import { render } from "./InvoicesPaidTable.vue?vue&type=template&id=6bb88ab4"
import script from "./InvoicesPaidTable.vue?vue&type=script&lang=js"
export * from "./InvoicesPaidTable.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__